import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import { Action, Fetch, Target } from '@studiometa/ui';
import Figure from './Figure.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Toast from './Toast/index.js';
import QuoteFormTracking from './QuoteFormTracking.js';
import ObfuscatedLink from './ObfuscatedLink.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      Action,
      Fetch,
      Target,
      Figure,
      QuoteFormTracking,
      Header,
      Cart,
      Toast,
      ObfuscatedLink,
      CollectionFilter: (app) =>
        importWhenVisible(
          () => import('./Collection/CollectionFilter.js'),
          'CollectionFilter',
          app,
        ),
      Product: (app) => importWhenVisible(() => import('./Product/index.js'), 'Product', app),
      Collection: (app) =>
        importWhenVisible(() => import('./Collection/index.js'), 'Collection', app),
      Blog: (app) => importWhenVisible(() => import('./Blog/index.js'), 'Blog', app),
      NewsletterForm: (app) =>
        importWhenVisible(() => import('./NewsletterForm.js'), 'NewsletterForm', app),
      PopinNewsletter: (app) =>
        importWhenVisible(() => import('./PopinNewsletter.js'), 'PopinNewsletter', app),
      LanguageModal: (app) =>
        importWhenVisible(() => import('./LanguageModal.js'), 'LanguageModal', app),
      ReassurancePanel: (app) =>
        importWhenVisible(() => import('./Product/ReassurancePanel.js'), 'ReassurancePanel', app),
      EcopartModal: (app) =>
        importWhenVisible(() => import('./Product/EcopartModal.js'), 'EcopartModal', app),
      ProductCardVariantMedia: (app) =>
        importWhenVisible(
          () => import('./ProductCardVariantMedia.js'),
          'ProductCardVariantMedia',
          app,
        ),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}
